import React from 'react';

const OurFounder = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">Our Founder</h1>
    
    <h2 className="text-2xl font-semibold mb-4">Bridging Cryptography, Secure Engineering and Regulated-Industry Insight</h2>
    
    <p className="mb-6">
      <strong>Daan Acohen, MSc</strong>, principal .NET & DevSecOps consultant, ISO 27001 lead implementer and long-standing open-source advocate, is the driving force behind <strong>quantumsafeaudit.com</strong>. Combining scientific rigour, deep software-engineering expertise and hands-on compliance leadership, he helps organisations migrate from today's classical encryption to tomorrow's post-quantum cryptography (PQC) before large-scale quantum computers arrive.
    </p>
    
    <hr className="border-gray-300 my-6" />
    
    <h2 className="text-2xl font-semibold mb-4">Professional Background</h2>
    
    <ul className="list-disc pl-5 mb-6">
      <li className="mb-2"><strong>18 years of software experience</strong> across biotech, healthcare, financial KYC and additive manufacturing.</li>
      <li className="mb-2"><strong>Master's degree in Bio-Pharmaceutical Sciences</strong>, underpinning an evidence-based approach to risk assessment and validation.</li>
      <li className="mb-2"><strong>ISO 27001 lead implementer and internal auditor</strong> with a proven record of guiding companies to certification.</li>
      <li className="mb-2"><strong>Modern technology stack:</strong> .NET 6,8,10, Go, Terraform, Azure DevOps, Docker, Kubernetes, MassTransit and secure-by-design CI/CD pipelines.</li>
      <li className="mb-2"><strong>Open-source & community leadership:</strong> founder of ".NETherlands", maintainer of several NuGet packages with more than four million cumulative downloads, and author of several award-winning technical publications.</li>
    </ul>
    
    <hr className="border-gray-300 my-6" />
    
    <h2 className="text-2xl font-semibold mb-4">Why Trust Daan with Your Quantum-Safe Journey?</h2>
    
    <ol className="list-decimal pl-5 mb-6">
      <li className="mb-2"><strong>Proven compliance outcomes</strong> – successfully delivered ISO 27001 certifications and continuous-improvement programmes.</li>
      <li className="mb-2"><strong>From research to production</strong> – a scientific mindset ensures rigorous risk assessment, validation and real-world implementation.</li>
      <li className="mb-2"><strong>Community-validated expertise</strong> – many package downloads and active stewardship of open-source projects.</li>
      <li className="mb-2"><strong>Practical, hands-on delivery</strong> – deploys measurable audit solutions, including the instant website scan featured here.</li>
    </ol>
    
    <hr className="border-gray-300 my-6" />
    
    <h2 className="text-2xl font-semibold mb-4">Mission Statement</h2>
    
    <blockquote className="bg-gray-100 p-4 border-l-4 border-gray-500 italic mb-6">
      "Every organisation deserves to remain cryptographically future-proof.
      My mission is to make quantum resilience measurable, actionable and affordable—starting with an instant website scan and culminating in a fully verified PQC deployment."
    </blockquote>
    
    <hr className="border-gray-300 my-6" />
    
    <h2 className="text-2xl font-semibold mb-4">Key Achievements at a Glance</h2>
    
    <ul className="list-disc pl-5 mb-6">
      <li className="mb-2">ISO 27001 certifications led and maintained</li>
      <li className="mb-2"><a href="https://github.com/ConnectingApps" className="text-blue-600 hover:underline">Open-source projects maintained</a></li>
      <li className="mb-2"><a href="https://www.nuget.org/profiles/DaanAcohen" className="text-blue-600 hover:underline">More than 100.000 NuGet downloads</a></li>
      <li className="mb-2">Secure request architectures designed and audited</li>
      <li className="mb-2">
        Several technical publications: <a href="https://www.google.com/search?q=site%3Acodeproject.com+daan+acohen" className="text-blue-600 hover:underline">CodeProject</a> and <a href="https://dev.to/daan_acohen" className="text-blue-600 hover:underline">Dev.to</a>
      </li>
    </ul>
    
    <hr className="border-gray-300 my-6" />
    
    <h2 className="text-2xl font-semibold mb-4">Ready to Become Quantum-Safe?</h2>
    
    <p className="mb-4">
      Whether you require an executive briefing on PQC risks, a phased migration roadmap or a turnkey ISO 27001 programme, Daan's blend of security governance and deep technical expertise makes him the ideal partner. Schedule a strategy conversation today to safeguard your organisation, before the quantum clock runs out.
    </p>
  </div>
);

export default OurFounder;